import styled from 'styled-components';

export const SubItem = styled.div<{ $selected: boolean }>`
  display: flex;
  padding: 7px 10px;
  margin: 0 10px;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  background: ${({ $selected, theme }) => ($selected ? theme.sidebar.itemSelected : '')};

  &:hover {
    background: ${({ $selected, theme }) => ($selected ? theme.sidebar.itemSelected : theme.sidebar.itemHover)};
  }
`;

export const SubItemTitle = styled.p<{ $isSelected: boolean }>`
  color: ${({ $isSelected }) => ($isSelected ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.7)')};
  font-size: 14px;
  letter-spacing: 0.4px;
  margin: 0 6px;
`;
